import React from "react";
import { Cart } from "../../../../Service/cart.service";
import Summary from "./components/Summary";
import CouponCodeSection from "./components/CouponCodeSection";
import useAccess from "../../../../Hooks/useAccess";
import CreditPlanInfo from "./components/CreditPlanInfo";
import "./Payment.scss";

interface PaymentProps {
  mode: "upgrade" | "addon_only" | "renew";
  userCart: Cart;
  selectedAddonId: string | null;
}
const Payment: React.FC<PaymentProps> = ({
  mode,
  userCart,
  selectedAddonId,
}) => {
  const { currentSubscription, currentPlan, currentLimits } = useAccess();

  const renderInfoContent = (type: "subscription" | "credit") => {
    if (!currentSubscription || !currentPlan || !currentLimits) return null;

    return (
      <CreditPlanInfo
        plan={currentPlan}
        subscription={currentSubscription}
        selectedPlanId={userCart.basePlan.planId}
        limits={currentLimits}
      />
    );
  };
  return (
    <div className="payment-section">
      {currentSubscription &&
        currentSubscription.mode === "credit" &&
        currentPlan &&
        currentPlan.type !== "free" &&
        mode === "upgrade" && (
          <div className="payment-info-section">
            {renderInfoContent("credit")}
          </div>
        )}
      <div className="payment-wrapper">
        <div className="coupon-code-section">
          <CouponCodeSection />
        </div>
        <div className="summary-section">
          <Summary
            mode={mode}
            selectedAddonId={selectedAddonId}
            userCart={userCart}
          />
        </div>
      </div>
    </div>
  );
};

export default Payment;
